import styled, { css } from 'styled-components';
import DEVICES from '../../common/styles/devices';
import { FONT_FAMILY } from '../../common/styles/fontStyles';
import COLORS from '../../common/styles/color-pallete';
import { BalanceValueProps } from './types';
import { CommonButton } from '@Components';

export const InstaPointsWrapper = styled.div`
  background-color: ${COLORS.lightShadedGrey};
  font-family: ${FONT_FAMILY.hellix.regular};
`;

export const HeaderWrapper = styled.div<{ $headerTitle?: boolean }>`
  background-color: ${({ $headerTitle }) =>
    $headerTitle === false ? 'transparent' : COLORS.dividerBlue};
  height: ${({ $headerTitle }) => ($headerTitle === false ? '230px' : '265px')};

  @media ${DEVICES.mobileXL} {
    height: ${({ $headerTitle }) => ($headerTitle === false ? '75px' : '160px')};
    margin-bottom: 68px;
  }
`;

export const PageHeading = styled.h1`
  font-size: 28px;
  line-height: 38px;
  font-family: ${FONT_FAMILY.hellix.bold};
  color: ${COLORS.black};
  padding-top: 60px;
  padding-bottom: 40px;

  @media ${DEVICES.mobileXL} {
    font-size: 20px;
    line-height: 24px;
    padding-top: 40px;
    padding-bottom: 28px;
  }
`;

export const PointsCard = styled.div`
  display: flex;
  text-align: center;
  position: absolute;
  background-color: ${COLORS.white};
  color: ${COLORS.black};
  width: 540px;
  height: 222px;
  border-radius: 16px;
  box-shadow: 0px 10px 24px rgba(0, 0, 0, 0.1);
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;

  @media ${DEVICES.mobileXL} {
    width: 335px;
    height: 136px;

    @media ${DEVICES.mobileM} {
      width: 280px;
    }
  }
`;

export const BalanceColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 62%;
  height: 100%;
  justify-content: center;
  margin-left: 60px;
  position: relative;
  text-align: left;

  &::after {
    content: '';
    position: absolute;
    right: 0;
    border-right: 1px solid ${COLORS.borderGrey};
    top: 20%;
    bottom: 20%;
  }

  @media ${DEVICES.mobileXL} {
    margin-left: 24px;

    &::after {
      display: none;
    }
  }
`;

export const BalanceValue = styled.div<BalanceValueProps>`
  color: ${({ $isNegative }: BalanceValueProps) => ($isNegative ? COLORS.red : COLORS.black)};
  font-size: 28px;
  line-height: 38px;
  font-family: ${FONT_FAMILY.hellix.bold};
  letter-spacing: 0px;
`;

export const BalanceValueOld = styled.div<BalanceValueProps>`
  color: ${COLORS.black};
  font-size: 60px;
  font-family: ${FONT_FAMILY.hellix.bold};
  line-height: 72px;
  text-align: left;

  @media ${DEVICES.mobileXL} {
    font-size: 40px;
    line-height: 48px;
  }
`;

export const BalanceLabelTextOld = styled.div`
  margin-top: 6px;
  font-size: 20px;
  font-family: ${FONT_FAMILY.hellix.regular};
  line-height: 24px;
  text-align: left;

  @media ${DEVICES.mobileXL} {
    margin-top: 0px;
    font-size: 16px;
    line-height: 21px;
  }
`;

export const ViewBreakdownLink = styled(CommonButton)`
  @media ${DEVICES.mobileXL} {
    font-size: 12px;
    line-height: 22px;
  }
`;

export const BalanceLabelText = styled.div`
  margin-top: 4px;
  font-size: 20px;
  font-family: ${FONT_FAMILY.hellix.regular};
  line-height: 100%;
  letter-spacing: 0px;

  @media ${DEVICES.mobileXL} {
    margin-top: 0px;
    font-size: 18px;
    line-height: 24px;
  }
`;

export const MonthSummaryColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 38%;
  height: 100%;
  text-align: left;
  justify-content: center;
  margin-left: 60px;

  @media ${DEVICES.mobileXL} {
    margin-left: 24px;
  }
`;

export const MonthLabel = styled.span`
  font-size: 18px;
  font-family: ${FONT_FAMILY.hellix.bold};
  line-height: 26px;
  margin-bottom: 4px;

  @media ${DEVICES.mobileXL} {
    font-size: 14px;
    line-height: 22px;
  }
`;

export const IpsEarnedText = styled.span`
  font-size: 16px;
  font-family: ${FONT_FAMILY.hellix.regular};
  line-height: 22px;
  margin-bottom: 4px;
  letter-spacing: 0px;

  @media ${DEVICES.mobileXL} {
    font-size: 12px;
    line-height: 18px;
  }
`;

export const IpsExpiringText = styled.span`
  font-size: 16px;
  font-family: ${FONT_FAMILY.hellix.regular};
  line-height: 22px;
  letter-spacing: 0px;

  @media ${DEVICES.mobileXL} {
    font-size: 12px;
    line-height: 18px;
  }
`;

export const BodyWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: auto;
  margin-top: 155px;
  max-width: 1150px;
  color: ${COLORS.black};
  padding: 0px 20px;

  @media ${DEVICES.mobileToTabletXL} {
    margin-top: 135px;
    flex-direction: column;
  }
  @media ${DEVICES.mobileXL} {
    margin-top: 90px;
  }
`;

export const LeftWrapper = styled.div`
  width: 66%;
  @media ${DEVICES.mobileToTabletXL} {
    width: 100%;
  }
`;

export const RightWrapper = styled.div`
  width: 32%;
  @media ${DEVICES.mobileToTabletXL} {
    width: 100%;
  }
`;

const HeadingCSS = css`
  font-size: 24px;
  font-family: ${FONT_FAMILY.hellix.regular};
  line-height: 38px;
  margin-bottom: 24px;
  @media ${DEVICES.tablet} {
    margin-bottom: 16px;
  }
  @media ${DEVICES.tab} {
    font-size: 20px;
    line-height: 24px;
    margin-bottom: 16px;
  }
`;

export const RedeemWrapper = styled.div`
  width: 100%;
`;

export const RedeemHeading = styled.div`
  ${HeadingCSS}
`;

export const RedeemCard = styled.div`
  background-color: ${COLORS.white};
  border: 1px solid ${COLORS.borderGrey};
  border-radius: 8px;
  box-sizing: border-box;
  padding: 24px 32px;
  margin-bottom: 24px;
  display: flex;

  .globalIcon {
    width: 60px;
    height: 60px;
  }

  @media ${DEVICES.mobileXL} {
    padding: 24px 16px;

    .globalIcon {
      width: 54px;
      height: 54px;
    }
  }
`;

export const RedeemCardContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-left: 24px;

  button {
    padding: 0 !important;
  }
  .leftColumn {
    width: 72%;

    .cardHeading {
      font-size: 18px;
      font-family: ${FONT_FAMILY.hellix.bold};
      line-height: 26px;
    }
    .cardMessage {
      font-size: 20px;
      font-family: ${FONT_FAMILY.hellix.regular};

      line-height: 24px;
      margin-bottom: 8px;
    }
    .cardSubMessage {
      white-space: pre-line;
      font-family: ${FONT_FAMILY.hellix.regular};
      line-height: 21px;
      color: ${COLORS.textLightGrey};
    }
  }

  .rightColumn {
    .redeemButton {
      cursor: pointer;
      background-color: ${COLORS.dividerBlue};
      border-radius: 4px;
      padding: 6px 16px;
      font-size: 16px;
      font-family: ${FONT_FAMILY.hellix.bold};
      line-height: 26px;
      border: none;
    }
    .redeemButtonBlocked {
      background-color: ${COLORS.textLightGrey};
      color: ${COLORS.lightGrey};
      border-radius: 4px;
      padding: 6px 16px;
      font-size: 16px;
      font-family: ${FONT_FAMILY.hellix.bold};
      line-height: 26px;
      border: none;
    }
  }

  @media ${DEVICES.mobileXL} {
    flex-direction: column;

    .leftColumn {
      width: 100%;

      .cardHeading {
        font-size: 16px;
      }
      .cardMessage {
        font-size: 14px;
        line-height: 17px;
        margin-bottom: 4px;
      }
      .cardSubMessage {
        font-size: 12px;
        line-height: 15px;
        margin-bottom: 12px;
      }
    }

    .rightColumn {
      width: 100%;
    }
  }
`;

export { AmazeBanner } from './Banner.style';

export const EarnInstapointsWrapper = styled.div`
  width: 100%;

  .earnInstapointsHeading {
    ${HeadingCSS}
  }

  @media ${DEVICES.tabletSToTabletXL} {
    margin-top: 40px;
  }

  @media ${DEVICES.tab} {
    margin-top: 60px;
  }

  /* Carousel for Mobile screen  */
  .amaze-carousel {
    .carousel-slider {
      .slide {
        text-align: left;
      }
      img {
        width: 64px;
        height: 87px;
      }

      li.slide.selected + li {
        margin-left: -10vw;
      }
    }
  }
`;

export const EarnCard = styled.div`
  background-color: ${COLORS.white};
  border: 1px solid ${COLORS.borderGrey};
  border-radius: 8px;
  box-sizing: border-box;
  padding: 24px 32px;
  margin-bottom: 16px;

  display: flex;

  .cardIcon {
    width: 64px;
    height: 87px;
  }

  @media ${DEVICES.mobileXL} {
    min-width: 200px;
    max-width: 75vw;
    max-height: 160px;
    padding: 24px 16px;
    margin: 0px 12px 16px 0px;
  }
`;

export const EarnCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-left: 16px;

  .leftColumn {
    width: 100%;

    .cardHeading {
      font-size: 18px;
      font-family: ${FONT_FAMILY.hellix.bold};
      line-height: 26px;
      margin-bottom: 6px;
    }
    .cardMessage {
      min-height: 60px;
      font-size: 16px;
      font-family: ${FONT_FAMILY.hellix.regular};
      line-height: 21px;
    }
  }

  .rightColumn {
    width: 100%;

    .earnLink {
      font-family: ${FONT_FAMILY.hellix.bold};
      cursor: pointer;
      color: ${COLORS.darkBlue};
      font-size: 16px;
      font-family: ${FONT_FAMILY.hellix.bold};
      line-height: 26px;
    }
  }

  @media ${DEVICES.mobileToTabletXL} {
    flex-direction: row;

    .leftColumn {
      width: 72%;

      .cardMessage {
        max-width: 300px;
      }
    }

    .rightColumn {
      width: 28%;
      text-align: right;
    }
  }

  @media ${DEVICES.mobileXL} {
    flex-direction: column;

    .leftColumn {
      width: 100%;

      .cardHeading {
        font-size: 16px;
      }
      .cardMessage {
        min-height: 50px;
        font-size: 14px;
        line-height: 17px;

        /* For Mobile Text-Overflow ellipsis
         added if more than 3 lines */
        /* overflow: hidden; */
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
    }

    .rightColumn {
      width: 100%;
      text-align: left;

      .earnLink {
        font-size: 14px;
      }
    }
  }
`;

export const ExpiringInstapointsWrapper = styled.div`
  margin: 60px 0px;

  .expiringInstapointsHeading {
    ${HeadingCSS}
  }

  @media ${DEVICES.tablet} {
    margin: 40px 0px;
  }

  @media ${DEVICES.tab} {
    margin: 60px 0px;
  }
`;

export const ExpiringCard = styled.div`
  background-color: ${COLORS.white};
  border: 1px solid ${COLORS.borderGrey};
  border-radius: 8px;
  box-sizing: border-box;
  padding: 28px 20px;
`;

export const ExpiringIconContainer = styled.div`
  display: flex;
  margin-bottom: 11px;

  .expiringIcon {
    width: 24px;
    height: 24px;
    z-index: 1;
  }

  .strokedLine {
    width: 90%;
  }

  .firstCol {
    width: 50%;
    display: flex;
    justify-content: flex-start;
  }
  .secondCol {
    width: 0%;
    display: flex;
    justify-content: center;
  }

  .thirdCol {
    width: 50%;
    display: flex;
    justify-content: flex-end;
  }
`;

export const ExpiringTimelineContainer = styled.div`
  display: flex;

  .firstCol {
    width: 33.3%;
    display: flex;
    justify-content: flex-start;
  }
  .secondCol {
    width: 33.3%;
    display: flex;
    justify-content: center;
    text-align: center;
  }

  .thirdCol {
    width: 33.3%;
    display: flex;
    justify-content: flex-end;
    text-align: right;
  }

  .expiringIpsMonth {
    font-size: 14px;
    font-family: ${FONT_FAMILY.hellix.bold};
    line-height: 22px;
  }

  .expiringMonth {
    font-size: 14px;
    font-family: ${FONT_FAMILY.hellix.regular};
    line-height: 22px;
  }
`;

export const HistoryInstapointsWrapper = styled.div`
  margin-top: 60px;

  .historyInstapointsHeading {
    ${HeadingCSS}
  }

  @media ${DEVICES.tablet} {
    margin-top: 40px;
  }

  @media ${DEVICES.tab} {
    margin-top: 60px;
  }
`;

export const CardHistoryContainer = styled.div`
  background-color: ${COLORS.white};
  border: 1px solid ${COLORS.borderGrey};
  border-radius: 8px;
  box-sizing: border-box;
  padding: 16px 20px;
  margin-bottom: 20px;
  .load-more-btn-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .cardHistoryHeader {
    display: flex;
    padding-bottom: 16px;

    span {
      font-size: 14px;
      font-family: ${FONT_FAMILY.hellix.bold};
      line-height: 26px;
      flex: 1;
    }

    span:nth-child(2) {
      text-align: center;
    }

    span:last-child {
      text-align: right;
    }

    @media ${DEVICES.mobileXL} {
      span:first-child {
        flex: 2;
      }
      span:nth-child(2) {
        text-align: right;
      }
    }
  }

  .loadMoreButton {
    border-top: 1px solid ${COLORS.borderGrey};
    padding: 16px 0px;
    text-align: center;
    font-size: 16px;
    line-height: 26px;
    font-family: ${FONT_FAMILY.hellix.bold};
    color: ${COLORS.brandPrimary};
    cursor: pointer;
  }

  .cardHistoryBody {
  }

  @media ${DEVICES.mobileXL} {
    .loadMoreButton {
      font-size: 14px;
      line-height: 22px;
    }
  }
`;

export const HistoryRow = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 0px;
  border-top: 1px solid ${COLORS.borderGrey};
  cursor: pointer;

  div {
    flex: 1;
  }

  div:first-child {
    display: flex;
    flex-direction: column;

    span:first-child {
      font-size: 16px;
      font-family: ${FONT_FAMILY.hellix.bold};
      line-height: 26px;
    }

    span:last-child {
      font-size: 14px;
      font-family: ${FONT_FAMILY.hellix.regular};
      line-height: 16px;
      margin-top: 4px;
    }
  }

  div:nth-child(2) {
    text-align: center;
    font-size: 16px;
    font-family: ${FONT_FAMILY.hellix.regular};
    line-height: 21px;
  }

  div:last-child {
    text-align: right;
    font-size: 16px;
    font-family: ${FONT_FAMILY.hellix.bold};
    line-height: 26px;
    color: ${COLORS.lightGreen};
  }

  @media ${DEVICES.mobileXL} {
    div:first-child {
      flex: 2;
    }
    div:nth-child(2) {
      text-align: right;
    }
  }
`;

interface ModalContainerProps {
  width: number;
}
export const ModalContainer = styled.div<ModalContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  isolation: isolate;
  width: ${(props: any) => props.width}px;
  background: ${COLORS.white};
  box-shadow: 0px -10px 24px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  @media (${DEVICES.mobileXL}) {
    width: ${(props: any) => props.width}px !important;
  }
  @media (${DEVICES.mobileM}) {
    width: 95% !important;
  }
`;

export const CloseModalIcon = styled.img`
  display: initial;
  width: 16px;
  align-self: end;
  justify-self: end;
  float: right;
  margin: 22px 22px 0 0;
  cursor: pointer;
`;

export const ModalBodyContainer = styled.div`
  width: 100%;
  padding: 22px 20px 32px 20px;
  gap: 32;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .globalIconContainer {
    margin-bottom: 24px;
  }
  .dismissButton {
    cursor: pointer;
    color: ${COLORS.brandPrimary};
    font-size: 16px;
    font-family: ${FONT_FAMILY.hellix.bold};
  }
  .sendMoneyRedeemBtn {
    cursor: pointer;
    background: ${COLORS.brandPrimary};
    width: 100%;
    height: 46px;
    border-radius: 4px;
    text-align: center;
    outline: none;
    border: none;
    color: ${COLORS.white};
    font-family: ${FONT_FAMILY.hellix.bold};
    font-family: ${FONT_FAMILY.hellix.bold};
    font-size: 16px;
    line-height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    @media ${DEVICES.mobileS} {
      width: 250px;
    }
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;
`;

interface HeadingTextProps {
  fontSize: number;
}
export const HeadingText = styled.span<HeadingTextProps>`
  text-align: center;
  font-size: ${(props: HeadingTextProps) => props.fontSize}px;
  font-family: ${FONT_FAMILY.hellix.bold};
  line-height: 38px;
  color: ${COLORS.black};
`;
export const HeadingDate = styled.span<HeadingTextProps>`
  color: ${COLORS.textLightGrey};
  margin-top: 8px;
  font-size: ${(props: HeadingTextProps) => props.fontSize}px;
  color: ${COLORS.black};
`;

export const TableContainer = styled.div`
  width: 100%;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const HorizontalRule = styled.div`
  width: 312px;
  margin: 8px 0;
  border-bottom: 1px solid ${COLORS.borderGrey};

  @media ${DEVICES.mobileS} {
    width: 250px;
  }
  @media ${DEVICES.mobileM} {
    width: 300px;
  }
`;

interface RowContainerProps {
  marginTop: number;
}

export const RowContainer = styled.div<RowContainerProps>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 8px 0 ${(props: RowContainerProps) => props.marginTop}px 0;
  @media ${DEVICES.mobileS} {
    width: 250px;
    justify-content: space-around;
  }
`;

interface IndividualRowProps {
  color: string;
  alignment: string;
}

export const IndividualRow = styled.span<IndividualRowProps>`
  font-size: 14px;
  color: ${(props: IndividualRowProps) => props.color};
  font-family: ${FONT_FAMILY.hellix.regular};
  text-align: ${(props: IndividualRowProps) => props.alignment};

  .copyPopup {
    width: 90px;
    left: -16px;
  }
  .copyIcon {
    cursor: pointer;
  }
  .rowValue {
    margin-left: 8px;
  }
`;

interface PopupRedeemDescriptionProps {
  bottomMargin: number;
}
export const PopupRedeemDescription = styled.span<PopupRedeemDescriptionProps>`
  width: 303px;
  margin: 0 0 ${(props: PopupRedeemDescriptionProps) => props.bottomMargin}px 0;
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 16px;
  line-height: 22px;
  text-align: center;

  @media ${DEVICES.mobileS} {
    width: 250px;
  }
`;

export const InstaremQrCode = styled.img`
  height: 125px;
  width: 125px;
  margin-top: 16px;
  margin-bottom: 40px;
`;

export const AppLinkContainer = styled.div`
  width: 100%;
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 24px;
  .app-link {
    width: 125px;
  }
  @media ${DEVICES.mobileS} {
    .app-link {
      width: 100px;
    }
  }
`;

export const DismissTextButton = styled.span`
  color: ${COLORS.brandPrimary};
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 16px;
  cursor: pointer;
`;
// ─── Rewards page ─────────────────────────────────────────────────────────────

export const RewardsPageWrapper = styled.div`
  background-color: ${COLORS.lightShadedGrey};
  font-family: inherit;
`;

export const BalanceTag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: ${COLORS.borderGrey};
  border-radius: 12px;
  padding: 4px 12px;
  font-size: 14px;
  line-height: 22px;
  font-family: ${FONT_FAMILY.hellix.bold};
  color: ${COLORS.black};
  margin-bottom: 10px;
  img {
    width: 15px;
    height: 15px;
  }
`;

export const WorthText = styled.div`
  font-size: 18px;
  color: ${COLORS.textGrey};
  margin-top: 4px;
  line-height: 24px;
`;

export const RewardsCenteredContent = styled.div`
  max-width: 700px;
  margin: 0 auto;
  padding-bottom: 48px;
  margin-top: 140px;
  background-color: ${COLORS.white};
  border-radius: 16px;
  padding: 0 24px 24px;

  @media ${DEVICES.mobileToTabletXL} {
    margin-top: 120px;
  }
  @media ${DEVICES.mobileXL} {
    margin-top: 85px;
    border-radius: 12px;
  }
`;

export const TabsBar = styled.div`
  display: flex;
  border-bottom: 1px solid ${COLORS.borderGrey};
  margin-bottom: 24px;
  background-color: ${COLORS.white};
`;

interface TabItemProps {
  $active: boolean;
}
export const TabItem = styled.div<TabItemProps>`
  flex: 1;
  text-align: center;
  padding: 14px 0;
  cursor: pointer;
  font-size: 20px;
  line-height: 26px;
  font-family: ${({ $active }: TabItemProps) =>
    $active ? `${FONT_FAMILY.hellix.bold}` : `${FONT_FAMILY.hellix.regular}`};
  color: ${({ $active }: TabItemProps) => ($active ? COLORS.brandPrimary : COLORS.textLightGrey)};
  border-bottom: ${({ $active }: TabItemProps) =>
    $active ? `4px solid ${COLORS.brandPrimary}` : `4px solid ${COLORS.borderGrey}`};
  transition: color 0.2s;

  @media ${DEVICES.mobileXL} {
    font-size: 15px;
    padding: 12px 0;
  }
`;

export const InfoCard = styled.div`
  background: ${COLORS.white};
  border: 1px solid ${COLORS.borderGrey};
  border-radius: 8px;
  padding: 16px 24px;
  margin-bottom: 24px;
  ul {
    margin: 0;
    padding-left: 18px;
    list-style-type: disc;
    li {
      font-size: 14px;
      line-height: 26px;
      color: ${COLORS.black};
      list-style-type: disc;
    }
  }
`;

export const StickyTabsOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 5;
  background-color: ${COLORS.white};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  animation: tabSlideUp 0.25s ease-out forwards;

  @keyframes tabSlideUp {
    from {
      opacity: 0;
      transform: translateY(-8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .stickyTabsInner {
    max-width: 700px;
    margin: 0 auto;
    padding: 0 24px;
    display: flex;
    border-bottom: 1px solid ${COLORS.borderGrey};
  }
`;

export const RewardsPointsCard = styled.div`
  display: flex;
  position: absolute;
  background-color: ${COLORS.white};
  color: ${COLORS.black};
  width: 540px;
  height: 190px;
  border-radius: 16px;
  box-shadow: 0px 10px 24px rgba(0, 0, 0, 0.1);
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;

  .firstCol {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 50%;
    height: 100%;
    justify-content: flex-start;
    padding-top: 36px;
    margin-left: 40px;

    .balanceLabel {
      font-size: 16px;
      font-family: ${FONT_FAMILY.hellix.regular};
      line-height: 22px;
      color: ${COLORS.textGrey};
    }

    .balanceValue {
      color: ${COLORS.black};
      font-size: 20px;
      font-family: ${FONT_FAMILY.hellix.bold};
      line-height: 26px;
    }

    .ipBalanceColorClass {
      color: ${COLORS.red};
    }
  }

  .secondCol {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 50%;
    height: 100%;
    justify-content: flex-start;
    padding-top: 36px;
    margin-left: 40px;

    .balanceLabel {
      font-size: 16px;
      font-family: ${FONT_FAMILY.hellix.regular};
      line-height: 22px;
      color: ${COLORS.textLightGrey};
    }

    .balanceValue {
      color: ${COLORS.black};
      font-size: 20px;
      font-family: ${FONT_FAMILY.hellix.bold};
      line-height: 26px;
      text-align: left;
    }

    .ipBalanceColorClass {
      color: ${COLORS.red};
    }
  }

  .verticalLine {
    position: relative;
  }
  .verticalLine:after {
    content: '';
    position: absolute;
    right: 0;
    border-right: 1px solid ${COLORS.borderGrey};
    top: 20%;
    bottom: 20%;
  }

  @media ${DEVICES.mobileXL} {
    width: 335px;
    height: 152px;

    .firstCol {
      margin-left: 24px;
      padding-top: 24px;

      .balanceLabel {
        font-size: 12px;
        line-height: 16px;
        margin-top: 4px;
      }
      .balanceValue {
        font-size: 22px;
        line-height: 28px;
      }
    }

    .secondCol {
      margin-left: 24px;
      padding-top: 24px;

      .balanceLabel {
        font-size: 12px;
        line-height: 16px;
        margin-top: 4px;
      }
      .balanceValue {
        font-size: 22px;
        line-height: 28px;
      }
    }

    @media ${DEVICES.mobileM} {
      width: 280px;
    }
  }
`;

export const TabContentSheet = styled.div`
  @media ${DEVICES.mobileXL} {
    padding: 0 16px 16px;
  }
`;

export const InviteCard = styled.div`
  background: ${COLORS.white};
  border: 1px solid ${COLORS.borderGrey};
  border-radius: 8px;
  padding: 24px;
  display: flex;
  align-items: center;
  .inviteImg {
    width: 64px;
    height: 80px;
    object-fit: contain;
    flex-shrink: 0;
    margin-right: 24px;
  }
  .inviteContent {
    flex: 1;
    .inviteTitle {
      font-size: 18px;
      font-family: ${FONT_FAMILY.hellix.bold};
      line-height: 26px;
      margin-bottom: 6px;
    }
    .inviteDesc {
      font-size: 14px;
      color: ${COLORS.textLightGrey};
      line-height: 20px;
      margin-bottom: 10px;
    }
    .inviteLink {
      color: ${COLORS.brandPrimary};
      font-family: ${FONT_FAMILY.hellix.bold};
      font-size: 14px;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  @media ${DEVICES.mobileXL} {
    padding: 16px;
    .inviteImg {
      width: 48px;
      height: 60px;
      margin-right: 16px;
    }
    .inviteContent .inviteTitle {
      font-size: 15px;
    }
  }
`;

// ─── IPs Breakdown Modal ───────────────────────────────────────────────────────

export const IpsBreakdownContainer = styled.div`
  background-color: ${COLORS.white};
  border-radius: 10px;
  padding: 20px 20px 32px;
  width: 30%;
  min-width: 400px;
  display: flex;
  flex-direction: column;
  align-self: center;

  @media ${DEVICES.mobileXL} {
    min-width: unset;
    width: 90%;
  }
`;

export const CloseWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  padding: 10px;
  cursor: pointer;
`;

export const ModalTitle = styled.h4`
  font-size: 18px;
  font-family: ${FONT_FAMILY.hellix.bold};
  color: ${COLORS.black};
  line-height: 26px;
  text-align: center;
  margin-bottom: 32px;
`;

export const BreakdownRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 16px;
`;

export const Border = styled.div`
  border-top: 1px solid ${COLORS.borderGrey};
  margin-top: 16px;
  padding-bottom: 16px;
`;

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RowLabel = styled.span`
  font-size: 16px;
  font-family: ${FONT_FAMILY.hellix.regular};
  color: ${COLORS.textGrey};
  line-height: 22px;
`;

export const RowSubLabel = styled.span`
  font-size: 16px;
  font-family: ${FONT_FAMILY.hellix.regular};
  color: ${COLORS.textLightGrey};
  line-height: 22px;
`;

export const RowValue = styled.span<BalanceValueProps>`
  font-size: 16px;
  font-family: ${FONT_FAMILY.hellix.bold};
  color: ${({ $isNegative }: BalanceValueProps) => ($isNegative ? COLORS.red : COLORS.black)};
  line-height: 24px;
`;

export const ButtonWrapper = styled.div`
  button {
    width: 100%;
  }
`;

// Cashback and Krisflyer banner ------------------------------

export const BannerWrapper = styled.div`
  display: flex;
  width: 100%;
  background: ${COLORS.black};
  margin-top: 60px;
  border-radius: 8px;
  @media ${DEVICES.mobileXL} {
    flex-direction: column;
  }
`;

export const IconWrapper = styled.div`
  flex: 0 0 15%;
  padding: 24px 0 0 16px;
  align-self: center;
  @media ${DEVICES.mobileXL} {
    padding: 0;
    img {
      width: 126px;
      height: 180px;
    }
  }
`;

export const Image = styled.img``;
export const ContentWrapper = styled.div`
  flex: 1;
  color: ${COLORS.white};
  padding: 40px 62px 40px 48px;
  @media ${DEVICES.mobileXL} {
    padding: 20px;
  }
`;
export const ContentHeader = styled.div`
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 28px;
  line-height: 38px;
  padding-bottom: 8px;
  @media ${DEVICES.mobileXL} {
    font-size: 24px;
    line-height: 36px;
    padding-bottom: 0;
  }
`;

export const ContentDescription = styled.div`
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 20px;
  line-height: 100%;
  @media ${DEVICES.mobileXL} {
    font-size: 16px;
    line-height: 22px;
  }
`;

export const ContentActionButtonWrapper = styled.div`
  padding-top: 24px;
  @media ${DEVICES.mobileXL} {
    display: flex;
    justify-content: center;
    button {
      width: 160px !important;
    }
  }
`;
